/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetOnboardingProgressQueryResponse,
  GetOnboardingProgress401,
  GetOnboardingProgress404,
} from '../types/GetOnboardingProgress.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getOnboardingProgress } from '../clients/getOnboardingProgress.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getOnboardingProgressQueryKey = () => [{ url: '/onboarding/progress' }] as const;

export type GetOnboardingProgressQueryKey = ReturnType<typeof getOnboardingProgressQueryKey>;

export function getOnboardingProgressQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getOnboardingProgressQueryKey();
  return queryOptions<
    GetOnboardingProgressQueryResponse,
    ResponseErrorConfig<GetOnboardingProgress401 | GetOnboardingProgress404>,
    GetOnboardingProgressQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getOnboardingProgress({ ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * {@link /onboarding/progress}
 */
export function useGetOnboardingProgress<
  TData = GetOnboardingProgressQueryResponse,
  TQueryData = GetOnboardingProgressQueryResponse,
  TQueryKey extends QueryKey = GetOnboardingProgressQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetOnboardingProgressQueryResponse,
        ResponseErrorConfig<GetOnboardingProgress401 | GetOnboardingProgress404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getOnboardingProgressQueryKey();

  const query = useQuery(
    {
      ...getOnboardingProgressQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetOnboardingProgress401 | GetOnboardingProgress404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
